import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import AppRoutes from './AppRoutes';
import * as referenceDataActions from '../actions/referenceDataActions';
import TopNav from '../components/common/TopNav';
import TopNavToggler from '../components/common/TopNavToggler';
import withAuth from '../hoc/withAuth';
import { userCanAccessSystem } from '../util/AdGroupsHelper';
import keycloakManager from '../keycloak';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
//import * as referenceDataActions from 'actions/referenceDataActions';

const propTypes = {
  isLoading: PropTypes.bool,
};

const env = window.env;

const App = () => {
  const [topNavIsOpen, setTopNavIsOpen] = useState(true);
  const [referenceDataLoaded, setReferenceDataLoaded] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (!userCanAccessSystem()) {
      keycloakManager.logout();
    } else {
      preloadReferenceData();
    }
  }, []);

  const preloadReferenceData = () => {
    dispatch(referenceDataActions.getAllReferenceData()).then(() => {
      setReferenceDataLoaded(true);
    });
  };

  const logout = () => {
    keycloakManager.logout();
  };

  const toggleTopNav = () => {
    setTopNavIsOpen((prev) => !prev);
  };

  if (!referenceDataLoaded) {
    return null; // Consider adding a loading spinner or message
  }

  return (
    <div className="app-layout">
      <div
        className="app-layout-sidebar"
        style={{ backgroundColor: env.BackgroundColor }}
      >
        <TopNavToggler onClick={toggleTopNav} envprops={env} />
      </div>
      <div className="app-layout-content">
        <TopNav isOpen={topNavIsOpen} logout={logout} envprops={env} />
        <AppRoutes location={location} />
      </div>
    </div>
  );
};

App.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    currentJobState: state.currentJobState,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(referenceDataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withAuth(App));
